enum MaterialType {
  DIFFUSE = 0,
  METAL = 1,
  GLASS = 2,
  EMISSIVE = 3
}

export default MaterialType;
